// extracted by mini-css-extract-plugin
export default {"actions":"Support_actions__j3WXF","btn":"Support_btn__xVoDb"};